import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {Field, formValueSelector} from "redux-form";
import InputField from "../../../../../core/components/forms/InputField";
import {checkCoupon, clearCoupon} from "../../../../actions/OrderActions";
import {Trans, withTranslation} from "react-i18next";

class PromoCode extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            error: undefined,
            formOpen: !!props.coupon,
        };

        if (!!props.coupon) {
            this.checkCoupon();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {couponInfo, coupon} = this.props;

        if (couponInfo !== prevProps.couponInfo) {
            this.checkError();
        }
    }

    checkCoupon = () => {
        const {coupon, checkCoupon} = this.props;

        if (coupon) {
            checkCoupon(coupon);
        } else {
            this.setState({
                error: 'Empty filed',
            });
        }
    };

    checkError = () => {
        const {couponInfo} = this.props;
        let error = undefined;

        if (couponInfo.isValid === 0) {
            error = 'Invalid code';
        } else if (couponInfo.isValid === 1) {
            error = 'Valid code';
        }

        this.setState({
            error: error,
        })
    };

    handleChange = () => {
        const {clearCoupon} = this.props;

        clearCoupon();
    };

    formToggle = () => this.setState({formOpen: !this.state.formOpen});

    renderForm = () => {
        const {t} = this.props;
        const {error, formOpen} = this.state;

        return <div>
            <span className="opener" onClick={this.formToggle}>
                <Trans>Have a Promo Code?</Trans>
                {' '}
                <span className="info-holder">
                    info
                    <span className="popup">
                        This is the place to claim your goods. Enter the promo code in the section
                        to the right and your free virtual good will be automatically added to your
                        Roblox account.
                    </span>
                </span>
            </span>
            {
                formOpen &&
                <div className="promo-code">
                    <div className="promo-holder">
                        <div className={`text-holder ${error ? 'has-error' : ''}`}>
                            <Field
                                name="coupon"
                                component={InputField}
                                type="text"
                                onChange={this.handleChange}
                                className="text"
                                placeholder={t('Enter promo code')}
                            />
                        </div>
                        <button className="btn" type="button" onClick={this.checkCoupon}><Trans>APPLY</Trans></button>
                    </div>
                    {error && <span className="text-error">{error}</span>}
                </div>
            }
        </div>
    };

    renderDiscount = () => {
        const {discount} = this.props;

        return <div>
            <div className="promo-code">
                <div className="promo-apply">
                    <ul className="order-info ">
                        <li>
                            <span className="heading"><Trans>Your savings</Trans></span>
                            <span className="price">-${discount.toFixed(2)}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    };

    render() {
        const {couponInfo} = this.props;
        const {formOpen} = this.state;

        return <div className={'promo-container' + (formOpen ? ' active' : '')}>
            {!couponInfo.isValid ? this.renderForm() : this.renderDiscount()}
        </div>
    }
}

PromoCode = withTranslation()(PromoCode);

const selector = formValueSelector('OrderForm');

export default connect(
    state => ({
        couponInfo: state.order.coupon,
        coupon: selector(state, 'coupon')
    }),
    dispatch => ({
        checkCoupon: coupon => dispatch(checkCoupon(coupon)),
        clearCoupon: () => dispatch(clearCoupon()),
    })
)(PromoCode);